import { css } from '@emotion/css';

export const buttonContainerStyles = css`
  margin-top: 7.2rem;
`;
